<template>

    <div>
      <b-card :id="'test' + requete.idRequete" class="modal-requeteOut">
        <b-row no-gutters>

        <b-button pill type="button" v-if="!selected"
          @click="addRequeteFrom()" :id="'add' + requete.idRequete" title="sélectionner la requête"
          class="nav-link1">ajouter <i class="fas fa-plus-circle"></i>
       </b-button>

        <b-button pill type="button" v-else
          @click="suppRequeteFrom()" title="déselectionner la requête"
          class="nav-link2">supprimer <i class="fas fa-trash-alt"></i>
        </b-button>

          <b-col md="9">
            <b-card-text class ="pt-2 pb-2">
              <div class="titreRequete pr-2">{{requete.titre}}</div>
              <p class="motCle pl-2">mots clés: {{requete.keywords}}</p>
            </b-card-text>
          </b-col>   
             
        </b-row>
    </b-card>
    </div>


</template>

<script>
import { ref } from 'vue';
import eventBus from '@/eventBus.js'

export default {
    name: 'RequeteItemNotInJeu',

    props: {  
        requete:{
            required:true,
            type:Object
        },
        idjeu:{
          type:Number
        },
        selected:{
          type:Boolean,
          default:false
        }
    },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    const disabled = ref(false);

    const addRequeteFrom = () => {
      eventBus.emit("addRequeteInJeu" + props.idjeu, props.requete);
      disabledButton();
    };
    const suppRequeteFrom = () => {
      eventBus.emit("suppRequeteInJeu" + props.idjeu, props.requete.idRequete);
      activatedButton();
    };

    const disabledButton = () => {
      const button = document.getElementById('add' + props.requete.idRequete);
      const card = document.getElementById('test' + props.requete.idRequete);
      if (button && card) {
        button.disabled = true;
        card.style.backgroundColor = 'grey';
      }
    };

    const activatedButton = () => {
      const button = document.getElementById('add' + props.requete.idRequete);
      const card = document.getElementById('test' + props.requete.idRequete);
      if (button && card) {
        button.disabled = false;
        card.style.backgroundColor = 'white';
      }
    }

    return {
      addRequeteFrom,
      suppRequeteFrom,
      disabledButton,
      activatedButton,
      disabled
    };
  }
};
</script>


<style>
.btn-info:disabled{
  background-color: grey;
  border-color: grey;
}
.titreRequete{
    display: inline;
  color: black;
  font-size: 20px;
}
.motCle{
  display: inline;
  color: black;
  font-size: 15px;
}
.modal-requeteOut {
  margin: 2px 1em;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}
</style>